import { render, staticRenderFns } from "./CustomerBudgetPdfForm.vue?vue&type=template&id=15b1b52a"
import script from "./CustomerBudgetPdfForm.vue?vue&type=script&lang=ts"
export * from "./CustomerBudgetPdfForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports